import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    screenWidth: 0,
    screenHeight: 0
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
